import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from 'react-router-dom';
import { helpers } from "@shared";
import classNames from "classnames";

const AddPayors = () => {

    const navigate = useNavigate(), location = useLocation();
    const [split, setSplit] = useState(false);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const onClick = () => {
        helpers.navigateNext(location, navigate, { skipPayors: !split });
    };

    return (
        <div className="page-content-wrapper gap-y-10">
            <div className="flex flex-col gap-y-5">
                <h1 className="page-header">Split the bill?</h1>
                <span className="page-subheader">Add other payors to help pay down the balance each month</span>
            </div>
            <div className="yesno-wrapper">
                <button type="button" className={classNames(`btn text-xl btn-yesno`, { "btn-primary": split }, { "btn-outline-primary": !split })} onClick={() => setSplit(true)}>Yes</button>
                <button type="button" className={classNames(`btn text-xl btn-yesno`, { "btn-primary": !split }, { "btn-outline-primary": split })} onClick={() => setSplit(false)}>No</button>
            </div>
            <button type="button" className="btn btn-primary" onClick={onClick}>Continue</button>
            <div className="reminder-wrapper">
                <span className="reminder-text-emphasis">Reminder:</span> As the primary account holder you are responsible for the full bill at the end of the month if others fail to pay
            </div>
        </div >
    );
};

export default AddPayors;
